/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'sarsaparilla';
import { formatErrorMessage, getNewId } from '../../utils/permitUtilsNew';

export default class ErrorBanner extends React.PureComponent {
    static propTypes = {
        errors: PropTypes.arrayOf(
            PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.shape({
                    error: PropTypes.string,
                }),
            ])
        ).isRequired,
        innerRef: PropTypes.shape({
            current: PropTypes.instanceOf(Element),
        }),
    };

    splitAtLineBreak(text) {
        return text.split('\n').map((item) => <li key={item}>{item}</li>);
    }

    renderErrors() {
        return this.props.errors.map((err) => {
            const errString = typeof err === 'string' ? err : (err && err.error) || false;
            if (errString) {
                return (
                    <div
                        key={errString}
                        ref={this.props.innerRef}
                        style={{ outline: 'none' }}
                        tabIndex="-1"
                    >
                        <Alert
                            type="error"
                            heading="Errors:"
                            key={getNewId()}
                            hasAriaLive
                        >
                            <ul>
                                {this.splitAtLineBreak(formatErrorMessage(errString))}
                            </ul>
                        </Alert>
                    </div>
                );
            }
            return null;
        });
    }

    render() {
        return <div aria-live="polite">{this.renderErrors()}</div>;
    }
}
